module.exports = __webpack_public_path__ + "media/images/logo-828ef677afec032bb47f0783ecd862f4.png";